import { defineNuxtPlugin, useCookie } from '#imports'

export default defineNuxtPlugin(() => {
  const utmSource = useCookie('utm_source', {
    // Session cookie - clears when browser closes
    maxAge: undefined,
  })

  // Capture utm_source from URL if present
  if (import.meta.client) {
    const urlParams = new URLSearchParams(window.location.search)
    const utmSourceParam = urlParams.get('utm_source')

    if (utmSourceParam) {
      utmSource.value = utmSourceParam
    }
  }
})
